import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import MetricStrip from '@/pages/home/components/MetricStrip';
import EntrySection from '@/pages/home/components/EntrySection';
import TimelineSection from '@/pages/home/components/TimelineSection';
import StoriesSection from '@/pages/home/components/StoriesSection';
import SchemeSection from '@/pages/home/components/SchemeSection';
import WarningSection from '@/pages/home/components/WarningSection';
import FaqSection from '@/pages/home/components/FaqSection';
import DownloadCta from '@/pages/home/components/DownloadCta';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <MetricStrip />
        <EntrySection />
        <TimelineSection />
        <StoriesSection />
        <SchemeSection />
        <WarningSection />
        <FaqSection />
        <DownloadCta />
      </main>
      <Footer />
    </div>
  );
}